import { render, staticRenderFns } from "./IsotopeHalfLifeViz.vue?vue&type=template&id=5181a6d0&scoped=true"
import script from "./IsotopeHalfLifeViz.vue?vue&type=script&lang=js"
export * from "./IsotopeHalfLifeViz.vue?vue&type=script&lang=js"
import style0 from "./IsotopeHalfLifeViz.vue?vue&type=style&index=0&id=5181a6d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181a6d0",
  null
  
)

export default component.exports